import React, { useMemo, useState } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Section,
  Carousel,
  Loading,
  HomeCard,
  ContinueWatchingSection,
  FeaturedList,
  ChannelPlayer
} from '../../components'

const HOME_CARD_INDEX = 3

const MediaPageView = ({ data, history }) => {
  const isHomePage = useMemo(() => data && data.friendlyId === 'home', [data])
  const [openPlayer, setOpenPlayer] = useState(false)
  const [openIframe, setOpenIframe] = useState(false)

  if (!data || !data.items) {
    return <Loading height='80vh' />
  }

  const carouselData = data.items[0]
  const homeCardIndex = isHomePage ? HOME_CARD_INDEX + 1 : HOME_CARD_INDEX
  const homeCardData = data.items[homeCardIndex]
  const topSectionsData = data.items.slice(
    isHomePage ? 2 : 1, // if home page, 1 is featured list
    homeCardIndex
  )
  const botSectionsData = data.items.slice(homeCardIndex + 1)
  const featuredListData = isHomePage && data.items[1]

  const handleSelectChannel = item => {
    item && history.push(`/live/${item.id}`)
  }

  const dismissPlayer = () => {
    setOpenPlayer(false)
    setOpenIframe(false)
    return history.goBack()
  }

  const SectionRails = ({ item, topSection }) => {
    return (
      <Section
        id={item.id}
        name={item.titleLocalized}
        sectionData={item.items}
        topSection={topSection}
        onChannelSelected={handleSelectChannel}
      />
    )
  }

  return (
    <div>
      <Carousel data={carouselData} onChannelSelected={handleSelectChannel} />
      {featuredListData && (
        <FeaturedList id={featuredListData.id} data={featuredListData.items} />
      )}
      {isHomePage && <ContinueWatchingSection />}
      {topSectionsData.map((item, index) => {
        const topSection = index === 0 && !isHomePage
        return <SectionRails item={item} topSection={topSection} key={index} />
      })}
      <HomeCard
        data={homeCardData && homeCardData.items && homeCardData.items[0]}
      />
      {botSectionsData.map((item, index) => {
        return (
          <SectionRails item={item} key={index} />
        )
      })}
      <ChannelPlayer
        openPlayer={openPlayer}
        openIframe={openIframe}
        dismissPlayer={dismissPlayer}
      />
    </div>
  )
}

export default withRouter(MediaPageView)